// extracted by mini-css-extract-plugin
export default {"modalOverlay":"XC-z","modalContent":"YC-z","header":"ZC-z","close":"_C-z"};